<template>
    <li class="flex flex-row items-end self-stretch place-self-stretch gap-4 pl-2">
        <Skeleton class="h-8 w-32 collection:bg-secondary-inverse" />
        <Skeleton class="h-8 w-24 collection:bg-secondary-inverse" />
    </li>
</template>

<script setup lang="ts">
import Skeleton from '@/vue/components/design-system/skeleton/Skeleton.vue'
</script>
